<div #scrollContainer class="app-container">
    <!-- Title service observable -->
    <!-- Original code commented for safety -->
    <!-- <ng-container *ngIf="title$ | async"></ng-container> -->

    <!-- New Angular 20 Control Flow -->
    @if (hasTitle()) {
    <ng-container></ng-container>
    }

    <dynamic-header #header (logout$)="logout()"></dynamic-header>

    <router-outlet></router-outlet>
    <webstore-dynamic-footer></webstore-dynamic-footer>

    <!-- App Notifications -->
    <!-- Notifications are now handled by MatSnackBar service -->

    <!-- push notification panel -->
    <!-- Original code commented for safety -->
    <!-- <push-notification-panel
    *ngIf="pushNotificationsService.showPrompt$ | async"
    [promt]="(pushNotificationsService.prompt$ | async)!"
    (subscribe$)="pushNotificationsService.subscribe()"
    (unsubscribe$)="pushNotificationsService.unsubscribe()"
  >
  </push-notification-panel> -->

    <!-- New Angular 20 Control Flow -->
    @if (pushNotificationsService.shouldShowPromptDelayed()) {
    <push-notification-panel [promptData]="pushNotificationsService.prompt()!" (subscribe$)="pushNotificationsService.subscribe()" (unsubscribe$)="pushNotificationsService.unsubscribe()">
    </push-notification-panel>
    }

    <!-- scroll to top button -->
    <!-- Original code commented for safety -->
    <!-- <button *ngIf="isScrolled" (click)="scrollToTop()" class="scroll-to-top"> -->

    <!-- New Angular 20 Control Flow -->
    @if (showScrollButton()) {
    <button (click)="scrollToTop()" class="scroll-to-top">
        <svg class="scroll-up-svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 122.88" style="enable-background: new 0 0 122.88 122.88" xml:space="preserve">
            <g>
                <path class="theme-color-stroke theme-color-fill" d="M122.88,61.44c0,33.93-27.51,61.44-61.44,61.44C27.51,122.88,0,95.37,0,61.44C0,27.51,27.51,0,61.44,0 C95.37,0,122.88,27.51,122.88,61.44L122.88,61.44z M88.07,77.9V59.54L61.44,40.21L34.81,59.54V77.9l26.63-19.33L88.07,77.9 L88.07,77.9L88.07,77.9z" />
            </g>
        </svg>
    </button>
    }
</div>